import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { HelpComponent } from "./help/help.component";
import { ErrorComponent } from "./error/error.component";
import { CitizenComponent } from './citizen/citizen.component';
import { LanguageWrapperComponent } from './main/language-wrapper/language-wrapper.component';

const routes: Routes = [
    { path: '', component: LanguageWrapperComponent },
    { path: ':lang', component: LanguageWrapperComponent,
        children: [
            { path: '', component: CitizenComponent },
            { path: 'help', component: HelpComponent },
            { path: 'error', component: ErrorComponent },
            { path: ':code', component: CitizenComponent }
        ]
    },

    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: []
})
export class AppRoutingModule { }
